import React from "react";
// import logo from './logo.svg';
// import './App.css';
import Temp from './components/weather/temp';

function App() {
  return (
    <>
      <Temp/>
    </>
  );
}

export default App;
